export interface Video {
  id: number;
  title: string;
  slug: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  tags: string[];
  uploadDate: string;
  isHD: boolean;
}

export const videos: Video[] = [
  {
    id: 1,
    title: "2024年度最受欢迎数字视频合集 - 高清无缓冲在线播放",
    slug: "2024-top-digital-videos",
    category: "hot",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20video%20player%20interface%20with%20play%20button%20on%20dark%20gradient%20background%2C%20cinematic%20lighting%20with%20warm%20orange%20and%20deep%20black%20tones%2C%20professional%20streaming%20platform%20aesthetic%2C%20high%20contrast%2C%20clean%20geometric%20composition&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    duration: "45:28",
    views: 1285000,
    rating: 9.2,
    description: "精心筛选的年度优质数字视频内容合集，涵盖热门品牌资源，支持免费高清在线播放，流畅不缓冲。本合集汇聚了平台年度播放量最高的视频内容，为用户提供一站式观影体验。",
    tags: ["合集", "热门", "高清", "2024"],
    uploadDate: "2024-08-15",
    isHD: true,
  },
  {
    id: 2,
    title: "数字视频平台新功能体验 - 流畅播放技术详解",
    slug: "platform-new-features",
    category: "91video",
    thumbnail: "https://readdy.ai/api/search-image?query=Digital%20streaming%20platform%20dashboard%20with%20video%20thumbnails%20grid%20layout%2C%20warm%20dark%20theme%20with%20red%20accents%2C%20modern%20UI%20design%2C%20professional%20tech%20aesthetic%2C%20clean%20minimal%20interface&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    duration: "32:15",
    views: 896000,
    rating: 8.9,
    description: "深度体验数字视频平台最新功能升级，了解流畅播放背后的技术架构。91视频专区带来全新用户体验，不卡顿不缓冲，畅享高清画质。",
    tags: ["体验", "技术", "91视频", "流畅"],
    uploadDate: "2024-08-10",
    isHD: true,
  },
  {
    id: 3,
    title: "97视频独家内容 - 精彩大片不间断连播",
    slug: "97video-exclusive-marathon",
    category: "97video",
    thumbnail: "https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20warm%20golden%20lighting%20on%20dark%20background%2C%20movie%20theater%20aesthetic%20with%20red%20velvet%20curtains%2C%20professional%20video%20production%20theme%2C%20dramatic%20lighting%20composition&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    duration: "58:42",
    views: 1560000,
    rating: 9.5,
    description: "97视频品牌独家内容连播，精彩大片不间断放送。高清画质配合流畅播放技术，为用户带来沉浸式观影体验。",
    tags: ["独家", "97视频", "大片", "连播"],
    uploadDate: "2024-08-08",
    isHD: true,
  },
  {
    id: 4,
    title: "51视频网站热门精选 - 一周播放量排行榜",
    slug: "51video-weekly-chart",
    category: "51video",
    thumbnail: "https://readdy.ai/api/search-image?query=Video%20ranking%20chart%20display%20with%20numbered%20list%20on%20dark%20sleek%20background%2C%20warm%20amber%20highlights%2C%20modern%20streaming%20platform%20design%2C%20clean%20typography%20layout&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    duration: "25:10",
    views: 720000,
    rating: 8.7,
    description: "51视频网站一周热门内容排行榜，精选播放量最高的视频内容，让您不错过任何精彩瞬间。",
    tags: ["排行榜", "51视频", "热门", "周榜"],
    uploadDate: "2024-08-05",
    isHD: false,
  },
  {
    id: 5,
    title: "超清4K画质体验 - 数字视频平台画质对比",
    slug: "4k-quality-comparison",
    category: "hd",
    thumbnail: "https://readdy.ai/api/search-image?query=Ultra%20HD%204K%20resolution%20comparison%20display%20on%20dark%20background%2C%20crystal%20clear%20visual%20quality%20demonstration%2C%20professional%20video%20tech%20theme%2C%20warm%20accent%20lighting%2C%20clean%20modern%20layout&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    duration: "18:55",
    views: 450000,
    rating: 9.0,
    description: "深入对比不同画质下的视频观看体验，4K超清画质带来前所未有的视觉享受。数字视频平台高清专区，畅享极致画质。",
    tags: ["4K", "画质", "高清", "对比"],
    uploadDate: "2024-08-01",
    isHD: true,
  },
  {
    id: 6,
    title: "最新上线 - 数字内容趋势解读与展望",
    slug: "latest-digital-trends",
    category: "latest",
    thumbnail: "https://readdy.ai/api/search-image?query=Digital%20content%20trend%20visualization%20with%20data%20charts%20and%20graphs%20on%20dark%20background%2C%20warm%20orange%20and%20red%20data%20points%2C%20modern%20analytics%20dashboard%20design%2C%20professional%20business%20aesthetic&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    duration: "22:30",
    views: 380000,
    rating: 8.5,
    description: "最新上线的数字内容趋势解读，带您了解行业发展方向。新内容第一时间上线，保持平台内容新鮮度。",
    tags: ["趋势", "最新", "解读", "展望"],
    uploadDate: "2024-07-28",
    isHD: true,
  },
  {
    id: 7,
    title: "91视频精品推荐 - 不可错过的经典内容",
    slug: "91video-classic-picks",
    category: "91video",
    thumbnail: "https://readdy.ai/api/search-image?query=Curated%20video%20collection%20display%20with%20golden%20frames%20on%20dark%20background%2C%20premium%20content%20selection%20theme%2C%20warm%20spotlight%20effect%2C%20elegant%20luxurious%20aesthetic%2C%20clean%20minimal%20layout&width=640&height=360&seq=video-thumb-07&orientation=landscape",
    duration: "35:20",
    views: 920000,
    rating: 9.3,
    description: "91视频精品推荐栏目，精心挑选不可错过的经典内容。高清画质，流畅播放，为您呈现最优质的观影选择。",
    tags: ["精品", "91视频", "经典", "推荐"],
    uploadDate: "2024-07-25",
    isHD: true,
  },
  {
    id: 8,
    title: "97视频新片速递 - 八月重磅内容前瞻",
    slug: "97video-august-preview",
    category: "97video",
    thumbnail: "https://readdy.ai/api/search-image?query=New%20release%20announcement%20billboard%20on%20cinematic%20dark%20background%2C%20coming%20soon%20theme%20with%20dramatic%20red%20lighting%2C%20movie%20premiere%20aesthetic%2C%20professional%20entertainment%20industry%20style&width=640&height=360&seq=video-thumb-08&orientation=landscape",
    duration: "15:45",
    views: 650000,
    rating: 8.8,
    description: "抢先了解97视频八月份即将上线的重磅内容。新片速递，让您第一时间掌握最新动态。",
    tags: ["新片", "97视频", "预告", "八月"],
    uploadDate: "2024-07-22",
    isHD: false,
  },
  {
    id: 9,
    title: "数字视频平台优化指南 - 告别缓冲畅快观看",
    slug: "no-buffering-guide",
    category: "hot",
    thumbnail: "https://readdy.ai/api/search-image?query=Streaming%20optimization%20concept%20with%20network%20speed%20visualization%20on%20dark%20tech%20background%2C%20fast%20data%20flow%20lines%20in%20warm%20orange%2C%20modern%20digital%20infrastructure%20theme%2C%20clean%20futuristic%20design&width=640&height=360&seq=video-thumb-09&orientation=landscape",
    duration: "28:10",
    views: 1100000,
    rating: 9.1,
    description: "全面解析数字视频平台优化技巧，教您如何告别缓冲卡顿，享受流畅高清的观影体验。覆盖网络设置、播放器优化等多个方面。",
    tags: ["优化", "不卡顿", "指南", "流畅"],
    uploadDate: "2024-07-20",
    isHD: true,
  },
  {
    id: 10,
    title: "51视频网站年度回顾 - 精彩瞬间大盘点",
    slug: "51video-year-review",
    category: "51video",
    thumbnail: "https://readdy.ai/api/search-image?query=Year%20in%20review%20collage%20with%20highlight%20moments%20on%20dark%20background%2C%20golden%20retrospective%20theme%2C%20warm%20nostalgic%20lighting%2C%20professional%20video%20production%20aesthetic%2C%20clean%20organized%20layout&width=640&height=360&seq=video-thumb-10&orientation=landscape",
    duration: "42:55",
    views: 780000,
    rating: 8.6,
    description: "回顾51视频网站一年来的精彩瞬间，盘点最受欢迎的经典内容。感谢广大用户的支持与厚爱。",
    tags: ["回顾", "51视频", "年度", "精彩"],
    uploadDate: "2024-07-15",
    isHD: true,
  },
  {
    id: 11,
    title: "高清专区视觉盛宴 - 极致画质观影体验",
    slug: "hd-visual-feast",
    category: "hd",
    thumbnail: "https://readdy.ai/api/search-image?query=Visual%20feast%20concept%20with%20vibrant%20color%20spectrum%20on%20dark%20background%2C%20crystal%20clear%20HD%20display%20theme%2C%20warm%20gradient%20lighting%2C%20professional%20cinema%20quality%20aesthetic%2C%20clean%20modern%20design&width=640&height=360&seq=video-thumb-11&orientation=landscape",
    duration: "20:35",
    views: 540000,
    rating: 9.4,
    description: "高清专区为您带来视觉盛宴，极致画质让每一个细节都清晰呈现。数字视频平台持续升级播放技术，确保最佳观影体验。",
    tags: ["高清", "视觉", "画质", "专区"],
    uploadDate: "2024-07-12",
    isHD: true,
  },
  {
    id: 12,
    title: "最新上线内容速览 - 每周新鲜视频推荐",
    slug: "latest-weekly-fresh",
    category: "latest",
    thumbnail: "https://readdy.ai/api/search-image?query=Fresh%20content%20notification%20with%20new%20badge%20on%20dark%20background%2C%20weekly%20update%20theme%20with%20warm%20amber%20highlights%2C%20modern%20app%20interface%20design%2C%20clean%20notification%20layout&width=640&height=360&seq=video-thumb-12&orientation=landscape",
    duration: "16:20",
    views: 320000,
    rating: 8.4,
    description: "每周为您推荐最新上线的视频内容，保持内容新鲜度。不错过任何一个精彩视频，数字视频平台持续更新。",
    tags: ["最新", "推荐", "每周", "新鲜"],
    uploadDate: "2024-07-10",
    isHD: false,
  },
];

export function getVideosByCategory(categorySlug: string): Video[] {
  return videos.filter((v) => v.category === categorySlug);
}

export function getVideoBySlug(slug: string): Video | undefined {
  return videos.find((v) => v.slug === slug);
}

export function getHotVideos(limit: number = 6): Video[] {
  return [...videos].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestVideos(limit: number = 6): Video[] {
  return [...videos].sort((a, b) => new Date(b.uploadDate).getTime() - new Date(a.uploadDate).getTime()).slice(0, limit);
}